export class MarsPeriodStatusService {
  constructor() {
    this.statuses = [
      { text: "PeriodOpened", status: "opened" },
      { text: "PeriodClosed", status: "closed" }
    ];
  }
  search(value) {
    return this.statuses.filter((elem) => elem.text.indexOf(value) !== -1);
  }
  async get() {
    return Promise.resolve({ data: { records: this.statuses } });
  }
}
